import { Session } from 'next-auth';

export const getBusinessUnitKey = (session: Session) => {
	return session.selectedBusinessUnit ?? session.defaultBusinessUnit;
};

export const getBusinessUnitName = (session: Session) => {
	const businessUnitKey = getBusinessUnitKey(session);
	const billingProfile = session.user.billingProfiles.find((profile) => profile.businessUnitKey === businessUnitKey);

	return billingProfile?.businessUnitName ?? undefined;
};
